/**
 * 공용 AI 서비스 프로토콜
 * 서버의 Gemini API와 통신하기 위한 Socket.IO 이벤트 및 인터페이스 정의
 */

export const AIProtocol = {
  // Emit (클라이언트 → 서버)
  REQUEST: "ai:request",

  // Listen (서버 → 클라이언트)
  RESPONSE: "ai:response",
  ERROR: "ai:error",
} as const;

export type AIProtocolType = typeof AIProtocol[keyof typeof AIProtocol];

/**
 * AI 요청 타입
 * 새로운 AI 기능 추가 시 여기에 타입 추가
 */
export type AIRequestType =
  | "fight_simulation" // 야차 시뮬레이션
  | "general"; // 일반 요청

/**
 * AI 요청 인터페이스
 */
export interface AIRequest {
  requestId: string; // 요청 식별자 (UUID)
  type: AIRequestType; // 요청 타입
  prompt: string; // AI에게 보낼 프롬프트
  context?: Record<string, unknown>; // 추가 컨텍스트 (선택)
}

/**
 * AI 응답 인터페이스
 */
export interface AIResponse<T = unknown> {
  requestId: string;
  success: boolean;
  data: T; // 요청 타입별 응답 데이터
  error?: string;
}

/**
 * FightSimulator 결과 인터페이스
 */
export interface FightSimulationResult {
  winProbabilityA: number; // 0-100 (B는 100-A, 승자는 >50이면 A, <50이면 B, =50이면 draw)
  story: string; // 싸움 스토리 (3-5문장)
  keyFactors: string[]; // 주요 승부 요인
}

/**
 * 승자 계산 유틸리티
 */
export const getWinner = (probabilityA: number): "A" | "B" | "draw" => {
  if (probabilityA > 50) return "A";
  if (probabilityA < 50) return "B";
  return "draw";
};

/**
 * B의 승률 계산 유틸리티
 */
export const getProbabilityB = (probabilityA: number): number => {
  return 100 - probabilityA;
};
